"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getLangLocale = _interopRequireDefault(require("./getLangLocale"));

var _formatName = _interopRequireDefault(require("./formatName"));

var formalNameLanguages = ['de', 'ja'];

var _default = function _default(_ref, options) {
  var givenName = _ref.givenName,
      familyName = _ref.familyName,
      email = _ref.email;
  var locale = options && options.locale || (0, _getLangLocale.default)();
  return formalNameLanguages.indexOf(locale) >= 0 || !givenName ? (0, _formatName.default)({
    firstName: givenName,
    lastName: familyName,
    email: email
  }, options) : givenName;
};

exports.default = _default;
module.exports = exports.default;